#import "../../NotifyTimeFields.graphql"
mutation NotifyTimeUpdate($input: NotifyTimeUpdateInput!) {
  notifyTimeUpdate(input: $input) {
    notifyTime {
      ...NotifyTimeFields
    }
  }
}
